/* eslint-disable prefer-const */
/* eslint-disable no-restricted-syntax */
import { forEach, last } from 'lodash'

const isNum = (v) => !isNaN(v)
const isStringNum = (v) => !isNaN(parseInt(v))
const split = (s) => s.split('!')
const indexOf = (s, v) => split(s).indexOf(v)
const includes = (s, v) => split(s).includes(v)
// eslint-disable-next-line
const toRem = (v) => { return isStringNum(v) ? negative + Number(v) * 0.25 + 'rem' : negative + v }
const newObject = (o = {}) => Object.assign(Object.create(null), o)
const classesCache = new Map()
const customCache = new Map()
const config = newObject({ separator: ':', screens: { sm: '640px', md: '768px', lg: '1024px', xl: '1280px' } })
let componentName
let addedScreens

const parentSheet = typeof document !== 'undefined' ? document.head.appendChild(document.createElement('style')).sheet : null

/*
export const exportCSS = () => {
  if (!parentSheet) return ''
  return [...parentSheet.cssRules]
    .filter((rule) => !rule.cssRules || rule.cssRules.length)
    .map((rule) => rule.cssText.replace(/^@media\s*{([\s\S]*)}$/, '$1'))
    .join('').replace(/[\s\n]+/g, ' ')
}
*/

const isObject = (value) => Object.prototype.toString.call(value) === '[object Object]'
const hex6 = (value) => {
  if (typeof value !== 'string') throw Error('Hex value is not a hex string ' + value)
  if (!value.startsWith('#')) value = '#' + value
  value = value.length === 4 ? value.slice(1).split('').map((v) => v + v).join('') : value.slice(1)
  if (!/^[0-9a-f]{6}$/i.test(value)) throw Error('Incorrect hex color format.')
  return value
}

const errorNotObject = (value) => {
  if (!isObject(value)) throw Error('Config value must be an object.')
}

const customColors = new Map()
// https://gist.github.com/bobspace/2712980 -- using the hash at the end
let cssColorNames = split('aliceblue!antiquewhite!aqua!aquamarine!azure!beige!bisque!black!blanchedalmond!blue!blueviolet!brown!burlywood!cadetblue!chartreuse!chocolate!coral!cornflowerblue!cornsilk!crimson!cyan!darkblue!darkcyan!darkgoldenrod!darkgray!darkgreen!darkkhaki!darkmagenta!darkolivegreen!darkorange!darkorchid!darkred!darksalmon!darkseagreen!darkslateblue!darkslategray!darkturquoise!darkviolet!deeppink!deepskyblue!dimgray!dodgerblue!feldspar!firebrick!floralwhite!forestgreen!fuchsia!gainsboro!ghostwhite!gold!goldenrod!gray!green!greenyellow!honeydew!hotpink!indianred !indigo !ivory!khaki!lavender!lavenderblush!lawngreen!lemonchiffon!lightblue!lightcoral!lightcyan!lightgoldenrodyellow!lightgrey!lightgreen!lightpink!lightsalmon!lightseagreen!lightskyblue!lightslateblue!lightslategray!lightsteelblue!lightyellow!lime!limegreen!linen!magenta!maroon!mediumaquamarine!mediumblue!mediumorchid!mediumpurple!mediumseagreen!mediumslateblue!mediumspringgreen!mediumturquoise!mediumvioletred!midnightblue!mintcream!mistyrose!moccasin!navajowhite!navy!oldlace!olive!olivedrab!orange!orangered!orchid!palegoldenrod!palegreen!paleturquoise!palevioletred!papayawhip!peachpuff!peru!pink!plum!powderblue!purple!red!rosybrown!royalblue!saddlebrown!salmon!sandybrown!seagreen!seashell!sienna!silver!skyblue!slateblue!slategray!snow!springgreen!steelblue!tan!teal!thistle!tomato!turquoise!violet!violetred!wheat!white!whitesmoke!yellow!yellowgreen')
let cssColorsHex = split('f0f8ff!faebd7!00ffff!7fffd4!f0ffff!f5f5dc!ffe4c4!000000!ffebcd!0000ff!8a2be2!a52a2a!deb887!5f9ea0!7fff00!d2691e!ff7f50!6495ed!fff8dc!dc143c!00ffff!00008b!008b8b!b8860b!a9a9a9!006400!bdb76b!8b008b!556b2f!ff8c00!9932cc!8b0000!e9967a!8fbc8f!483d8b!2f4f4f!00ced1!9400d3!ff1493!00bfff!696969!1e90ff!d19275!b22222!fffaf0!228b22!ff00ff!dcdcdc!f8f8ff!ffd700!daa520!808080!008000!adff2f!f0fff0!ff69b4!cd5c5c!4b0082!fffff0!f0e68c!e6e6fa!fff0f5!7cfc00!fffacd!add8e6!f08080!e0ffff!fafad2!d3d3d3!90ee90!ffb6c1!ffa07a!20b2aa!87cefa!8470ff!778899!b0c4de!ffffe0!00ff00!32cd32!faf0e6!ff00ff!800000!66cdaa!0000cd!ba55d3!9370d8!3cb371!7b68ee!00fa9a!48d1cc!c71585!191970!f5fffa!ffe4e1!ffe4b5!ffdead!000080!fdf5e6!808000!6b8e23!ffa500!ff4500!da70d6!eee8aa!98fb98!afeeee!d87093!ffefd5!ffdab9!cd853f!ffc0cb!dda0dd!b0e0e6!800080!ff0000!bc8f8f!4169e1!8b4513!fa8072!f4a460!2e8b57!fff5ee!a0522d!c0c0c0!87ceeb!6a5acd!708090!fffafa!00ff7f!4682b4!d2b48c!008080!d8bfd8!ff6347!40e0d0!ee82ee!d02090!f5deb3!ffffff!f5f5f5!ffff00!9acd32')
for (let i = 0; i < cssColorNames.length; i++) {
  customColors.set(cssColorNames[i], cssColorsHex[i])
}
cssColorNames = undefined
cssColorsHex = undefined

export const configure = (conf = newObject()) => {
  for (let s of split('separator!prefix')) {
    if (conf[s] !== undefined && typeof conf[s] !== 'string') throw Error(`config.${s} must be a string.`)
  }
  if (conf.screens) errorNotObject(conf.screens)
  if (conf.colors) {
    errorNotObject(conf.colors)
    for (let [key1, value1] of Object.entries(conf.colors)) {
      if (isObject(value1)) {
        for (let [key2, value2] of Object.entries(value1)) {
          if (key2 === 'default') customColors.set(key1, hex6(value2))
          else customColors.set(key1 + '-' + key2, hex6(value2))
        }
      }
      else {
        customColors.set(key1, hex6(value1))
      }
    }
  }
  else {
    Object.assign(config, conf)
  }
}

const media = new Map()
const setMedia = (prefix, size) => {
  const condition = size ? `(min-width:${size})` : ''
  for (let i = 0; i < 3; i++) {
    media.set(prefix + i, parentSheet.cssRules[parentSheet.insertRule(`@media${condition}{}`, parentSheet.cssRules.length)])
  }
}

let cls
let originalClass

export const processClasses = (classes) => {
  if (typeof window === 'undefined') return
  if (!addedScreens) {
    addedScreens = true
    let entries = Object.entries(config.screens)
    for (const m of split('custom!default')) {
      setMedia(m)
      for (const [key, size] of entries) {
        setMedia(m + key, size)
      }
    }
  }
  // SVGAnimatedString
  if (typeof classes === 'object') classes = classes.baseVal
  if (typeof classes === 'string') {
    classes = classes.trim()
    if (!classesCache.has(classes)) {
      for (cls of classes.replace(/\s\s+/g, ' ').split(' ')) {
        if (!classesCache.has(cls)) {
          classesCache.set(cls, true)
          processClass()
        }
      }
      classesCache.set(classes, true)
    }
  }
}

const formatters = newObject({
  p: 'padding',
  m: 'margin',
  h: 'height',
  z: 'z-index',
  w: 'width'
})

const classNames = newObject()

// direct map from class to values
// eslint-disable-next-line
for (let c of split('box-border|-webkit-box-sizing:border-box;box-sizing:border-box!box-content|-webkit-box-sizing:content-box;box-sizing:content-box!hidden|display:none!object-scale-down|object-fit:scale-down;-o-object-fit:scale-down!scrolling-touch|-webkit-overflow-scrolling:touch!scrolling-auto|-webkit-overflow-scrolling:auto!visible|visibility:visible!invisible|visibility:hidden!order-first|order:-9999!order-last|order:9999!order-none|order:0!grid-cols-none|grid-template-columns:none!col-auto|grid-column:auto!col-start-auto|-ms-grid-column:auto;grid-column-start:auto!col-end-auto|-ms-grid-column-span:auto;grid-column-end:auto!grid-rows-none|-ms-grid-rows:none;grid-template-rows:none!row-auto|grid-row:auto!row-start-auto|-ms-grid-row:auto;grid-row-start:auto!row-end-auto|-ms-grid-row-span:auto;grid-row-end:auto!gap-px|gap:1px!row-gap-px|row-gap:1px!grid-flow-row|grid-auto-flow:row!grid-flow-col|grid-auto-flow:column!grid-flow-row-dense|grid-auto-flow:row dense!grid-flow-col-dense|grid-auto-flow:column dense!min-w-full|min-width:100%!max-w-full|max-width:100%!max-w-xs|max-width:16rem!max-w-sm|max-width:24rem!max-w-md|max-width:28rem!max-w-lg|max-width:32rem!max-w-xl|max-width:36rem!max-w-2xl|max-width:42rem!max-w-3xl|max-width:48rem!max-w-4xl|max-width:56rem!max-w-5xl|max-width:64em!max-w-6xl|max-width:72rem!max-w-7xl|max-width:80rem!max-w-screen-sm|max-width:640px!max-w-screen-md|max-width:768px!max-w-screen-lg!max-width:1024px!max-w-screen-xl|max-width:1280px!max-w-none|max-width:none!max-w-min|max-width:min-content!max-w-max|max-width:max-content!max-w-prose|max-width:65ch!min-h-full|min-height:100%!min-h-screen|min-height:100vh!max-h-full|max-height:100%!max-h-screen|max-height:100vh!text-2xl|font-size:1.5rem!text-3xl|font-size:1.875rem!text-4xl|font-size:2.25rem!italic|font-style:italic!not-italic|font-style:normal!underline|text-decoration:underline!line-through|text-decoration:line-through!no-underline|text-decoration:none!uppercase|text-transform:uppercase!lowercase|text-transform:lowercase!capitalize|text-transform:capitalize!normal-case|text-transform:none!whitespace-no-wrap|white-space:nowrap!break-normal|word-break:normal;overflow-wrap:normal!break-words|overflow-wrap:break-word!break-all|word-break:break-all!truncate|overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap!h-auto|height:auto!max-w-2xl|max-width:42rem!tracking-tightest|letter-spacing:-0.05em!tracking-tighter|letter-spacing:-0.025em!tracking-tight|letter-spacing:-0.0125em!tracking-normal|0!tracking-wide:letter-spacing:0.0125em!tracking-wider|letter-spacing:0.025em!tracking-widest|letter-spacing: 0.05em!leading-none|line-height:1!leading-tight|line-height:1.25!leading-snug|line-height:1.375!leading-normal|line-height:1.5!leading-relaxed|line-height:1.625!leading-loose|line-height:2!list-none|list-style-type:none!list-disc|list-style-type:disc!list-decimal|list-style-type:decimal!list-inside|list-style-position:inside!list-outside|list-style-position:outside!border|border-width:1px!border-collapse|border-collapse:collapse!border-separate|border-collapse:separate!table-auto|table-layout:auto!table-fixed|table-layout:fixed!appearance-none|-webkit-appearance:none;-moz-appearance:none;appearance:none!outline-none|outline:0!resize-none|resize:none!resize|resize:both!resize-y|resize:vertical!resize-x|resize:horizontal!fill-current|fill:currentColor!stroke-current|stroke:currentColor!sr-only|position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0!not-sr-only|position:static;width:auto;height:auto;padding:0;margin:0;overflow:visible;clip:auto;white-space:normal!font-sans|font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji!font-serif|font-family:Georgia,Cambria,"Times New Roman",Times,serif!font-mono|font-family:Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace!sticky|position:-webkit-sticky;position:sticky')) {
  const [k, v] = c.split('|')
  classNames[k] = v
}

// class to value
for (let c of split('float-right!float-left!float-none!clear-left!clear-right!clear-both!clear-none')) {
  classNames[c] = c.replace('-', ':')
}

// display
for (let c of split('block!flow-root!inline-block!inline-flex!inline!flex!grid!inline-grid!table!table-caption!table-cell!table-column!table-column-group!table-footer-group!table-header-group!table-row-group!table-row')) {
  let p = c
  if (c === 'flex') {
    p = '-webkit-box;display:-ms-flexbox;display:-webkit-flex;display:flex'
  }
  else if (c === 'inline-flex') {
    p = '-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex'
  }
  else if (c === 'grid') {
    p = '-ms-grid;display:grid'
  }
  else if (c === 'inline-grid') {
    p = '-ms-inline-grid;display:inline-grid'
  }
  classNames[c] = 'display:' + p
}

// position
for (let c of split('static!fixed!absolute!relative')) {
  classNames[c] = 'position:' + c
}

// https://tailwindcss.com/docs/customizing-colors
const colors = split('f7fafc!edf2f7!e2e8f0!cbd5e0!a0aec0!718096!4a5568!2d3748!1a202c!fee2e2!fecaca!fca5a5!f87171!ef4444!dc2626!b91c1c!991b1b!7f1d1d!ffedd5!fed7aa!fdba74!fb923c!f97316!ea580c!c2410c!9a3412!7c2d12!fef9c3!fef08a!fde047!facc15!eab308!ca8a04!a16207!854d0e!713f12!dcfce7!bbf7d0!86efac!4ade80!22c55e!16a34a!15803d!166534!14532d!e6fffa!b2f5ea!81e6d9!4fd1c5!38b2ac!319795!2c7a7b!285e61!234e52!dbeafe!bfdbfe!93c5fd!60a5fa!3b82f6!2563eb!1d4ed8!1e40af!1e3a8a!ebf4ff!c3dafe!a3bffa!7f9cf5!667eea!5a67d8!4c51bf!434190!3c366b!faf5ff!e9d8fd!d6bcfa!b794f4!9f7aea!805ad5!6b46c1!553c9a!44337a!fff5f7!fed7e2!fbb6ce!f687b3!ed64a6!d53f8c!b83280!97266d!702459!fef3c7!fde68a!fcd34d!fbbf24!f59e0b!d97706!b45309!92400e!78350f!cffafe!a5f3fc!67e8f9!22d3ee!06b6d4!0891b2!0e7490!155e75!164e63!ecfccb!d9f99d!bef264!a3e635!84cc16!65a30d!4d7c0f!3f6212!365314!ffe4e6!fecdd3!fda4af!fb7185!f43f5e!e11d48!be123c!9f1239!881337!fae8ff!f5d0fe!f0abfc!e879f9!d946ef!c026d3!a21caf!86198f!701a75!d1fae5!a7f3d0!6ee7b7!34d399!10b981!059669!047857!065f46!064e3b!e0f2fe!bae6fd!7dd3fc!38bdf8!0ea5e9!0284c7!0369a1!075985!0c4a6e!ede9fe!ddd6fe!c4b5fd!a78bfa!8b5cf6!7c3aed!6d28d9!5b21b6!4c1d95!f1f5f9!e2e8f0!cbd5e1!94a3b8!64748b!475569!334155!1e293b!0f172a')
const colorNames = split('gray!red!orange!yellow!green!teal!blue!indigo!purple!pink!amber!cyan!lime!rose!fuchsia!emerald!sky!violet!slate')
const roundedSize = split('none!sm!nm!md!lg!xl!2xl!full')
const edge = newObject({ l: 'left', r: 'right', t: 'top', b: 'bottom' })

const setColor = (type) => {
  if (secondPart === 'opacity' && isNum(thirdPart)) {
    rule = `--${type}-opacity:` + (thirdPart === '100' ? '1' : thirdPart / 100)
  }
  else {
    const [color, opacity] = parseColor()    
    if (color) {
      rule = type + `:rgba(${parseInt(color.slice(0, 2), 16)},${parseInt(color.slice(2, 4), 16)},${parseInt(color.slice(4, 6), 16)},var(--${type}-opacity,${opacity}))`
      // rule = type + `:#${color};` + rgba
    }
    else if (secondPart === 'current') {
      rule = type + ':currentColor'
    }
    else if (secondPart === 'inherit') {
      rule = type + ':inherit'
    }
    else if (secondPart === 'transparent') {
      rule = type + ':transparent'
    }
    else {
      rule = type + ':' + rest
      // console.log(rule)
    }
  }
}

const parseColor = () => {
  let opacity = 1
  let color
  if (thirdPart) {
    let colorPos = colorNames.indexOf(secondPart)
    color = colors[colorPos * 9 + (Number(thirdPart[0]) - 1)]
    const thirdPartArray = thirdPart.split('/')
    if (thirdPartArray[1] && isNum(thirdPartArray[1])) opacity = Number(thirdPartArray[1])/100
  }
  if (!color) {
    let opacityString
    [color, opacityString] = rest.replace(/\s/g, '-').split('/')
    color = customColors.get(color)
    if (color) {
      if (opacityString && isNum(opacityString)) opacity = Number(opacityString)/100
    }
    else if (secondPart && secondPart.startsWith('#')) {
      [color, opacityString] = secondPart.split('/')
      try {
        color = hex6(color)
        if (opacityString && isNum(opacityString)) opacity = Number(opacityString)/100
      }
      catch {}
    }
  }
  return [color, opacity]
}

const setPosition = () => {
  if (!fourthPart && (includes('auto!initial!inherit', lastPart) || isStringNum(lastPart))) {
    if (isNum(lastPart)) lastPart = Number(lastPart) * 0.25 + 'rem'
    else if (lastPart.indexOf('/') > -1) {
      let [top, bottom] = secondPart.split('/')
      if (isNum(top) && isNum(bottom)) lastPart = (100 * Number(top) / Number(bottom)).toFixed(2) + '%'
    }
    let v = negative + lastPart
    if (thirdPart) {
      sheetLevel = 1
      if (secondPart === 'y') {
        rule = `top:${v};bottom:` + v
      }
      else if (secondPart === 'x') {
        rule = `left:${v};right:` + v
      }
    }
    else if (secondPart) {
      if (firstPart === 'inset') {
        rule = `top:${v};right:${v};bottom:${v};left:` + v
      }
      else {
        sheetLevel = 2
        rule = firstPart + ':' + v
      }
    }
  }
}

const timeProp = () => {
  let v
  if (isNum(secondPart)) v = secondPart + 'ms'
  else if (isStringNum(secondPart)) v = secondPart
  if (v) rule = `-webkit-transition-${firstPart}:${v};-o-transition-${firstPart}:${v};transition-${firstPart}:` + v
}

const cls2process = newObject({
  object: () => {
    if (includes('contain!cover!fill!none!bottom', rest)) {
      rule = `-o-object-fit:${rest};object-fit:` + rest
    }
    else if (includes('bottom!center!left!left-bottom!left-top!right!right-bottom!right-top!top', rest)) {
      rest = rest.replace('-', ' ')
      rule = `-o-object-position:${rest};object-position:` + rest
    }
  },
  overflow: () => {
    if (includes('x!y', secondPart)) sheetLevel = 1
    rule = partsWithoutEnd + ':' + lastPart
  },
  clearfix: () => {
    originalClass = 'clearfix::after'
    rule = 'content:"";display:table;clear:both'
  },
  text: () => {
    let pos = indexOf('xs!sm!base!lg!xl', secondPart)
    if (pos > -1) {
      rule = `font-size:${0.75 + (0.125 * pos)}rem`
    }
    else if (secondPart.endsWith('xl')) {
      let [num] = secondPart.split('x')
      if (isNum(num)) rule = `font-size:${Number(num) - 2}rem`
    }
    else if (includes('left!center!right!justify', rest)) {
      rule = 'text-align:' + rest
    }
    else {
      setColor('color')
    }
  },
  font: () => {
    let pos = indexOf('hairline!thin!light!normal!medium!semibold!bold!extrabold!black', secondPart)
    if (pos > -1) {
      rule = 'font-weight:' + (100 * (1 + pos))
    }
    else if (isNum(secondPart)) {
      rule = 'font-weight:' + secondPart
    }
  },
  whitespace: () => {
    if (includes('normal!pre!pre-line!pre-wrap', rest)) rule = 'white-space:' + rest
  },
  inset: setPosition,
  top: setPosition,
  right: setPosition,
  bottom: setPosition,
  left: setPosition,
  flex: () => {
    let ruleFunc = (v1, v2 = 1, v3 = '0%') => `-webkit-box-flex:${v1};-ms-flex:${v1} ${v2} ${v3};flex:${v1} ${v2} ` + v3
    if (includes('row!row-reverse!col!col-reverse', rest)) {
      rest = rest.replace('col', 'column')
      rule = `-webkit-box-orient:${secondPart === 'row' ? 'horizontal' : 'vertical'};-webkit-box-direction:${thirdPart === 'reverse' ? thirdPart : 'normal'};-ms-flex-direction:${rest};flex-direction:${rest}`
    }
    else if (includes('no-wrap!wrap!wrap-reverse', rest)) {
      if (rest === 'no-wrap') rest = 'nowrap'
      rule = `-ms-flex-wrap:${rest};flex-wrap:${rest}`
    }
    else if (includes('grow!shrink', secondPart)) {
      sheetLevel = 1
      let v = thirdPart || 1
      if (secondPart === 'grow') {
        rule = `-webkit-box-flex:${v};-ms-flex-positive:${v};flex-grow:${v}`
      }
      else {
        rule = `-ms-flex-negative:${v};flex-shrink:${v}`
      }
    }
    else if (rest === 'initial') {
      rule = ruleFunc(0, 1, 'auto')
    }
    else if (rest === 'auto') {
      rule = ruleFunc(1, 1, 'auto')
    }
    else if (rest === 'none') {
      rule = '-webkit-box-flex:0;-ms-flex:none;flex:none'
    }
    else if (fourthPart) {
      rule = ruleFunc(secondPart, thirdPart, fourthPart)
    }
    else if (thirdPart) {
      rule = ruleFunc(secondPart, thirdPart)
    }
    else {
      rule = ruleFunc(secondPart)
    }
  },
  order: () => {
    if (isNum(secondPart)) {
      let num = negative + secondPart
      rule = `-webkit-box-ordinal-group:${Number(num) + 1};-ms-flex-order:${num};order:` + num
    }
  },
  grid: () => {
    if (isNum(thirdPart)) {
      rule = newObject({
        cols: `-ms-grid-columns:(minmax(0,1fr))[${thirdPart}];grid-template-columns: repeat(${thirdPart}, minmax(0, 1fr))`,
        span: `-ms-grid-column-span:${thirdPart};grid-column: span ${thirdPart} / span ` + thirdPart,
        start: `-ms-grid-column:${thirdPart};grid-column-start:` + thirdPart,
        end: `-ms-grid-column-span:${thirdPart};grid-column-end:` + thirdPart,
        rows: `-ms-grid-rows:(minmax(0,1fr))[${thirdPart}];grid-template-rows: repeat(${thirdPart}, minmax(0, 1fr))`
      })[secondPart]
    }
  },
  row: () => {
    if (isStringNum(thirdPart)) {
      rule = newObject({
        span: `-ms-grid-row-span:${thirdPart};grid-row: span ${thirdPart} / span ${thirdPart}`,
        start: `-ms-grid-row:${thirdPart};grid-row-start:` + thirdPart,
        end: `-ms-grid-row-span:${thirdPart};grid-row-end:` + thirdPart,
        gap: 'row-gap:' + toRem(thirdPart)
      })[secondPart]
    }
  },
  col: () => {
    if (isNum(thirdPart)) {
      if (secondPart === 'span') {
        rule = `-ms-grid-column-span:${thirdPart};grid-column:span ${thirdPart} / span ${thirdPart};`
      }
      else if (secondPart === 'start') {
        rule = `-ms-grid-column:${thirdPart};grid-column-start:${thirdPart}`
      }
      else if (secondPart === 'end') {
        rule = `-ms-grid-column-span:${thirdPart};grid-column-end:${thirdPart}`
      }
    }
    if (isStringNum(thirdPart) && secondPart === 'gap') {
      let v = thirdPart === 'px' ? '1px' : toRem(thirdPart)
      rule = `-webkit-column-gap:${v};-moz-column-gap:${v}column-gap:` + v
    }
  },
  gap: () => {
    if (isStringNum(secondPart)) {
      rule = 'gap:' + toRem(secondPart)
    }
    else if (isStringNum(thirdPart)) {
      if (secondPart === 'x') {
        rule = 'column-gap:' + toRem(thirdPart)
      }
      else if (secondPart === 'y') {
        rule = 'row-gap:' + toRem(thirdPart)
      }
    }
  },
  space: () => {
    pseudos = ['>:not(template)~:not(template)']
    if (thirdPart === 'px') {
      thirdPart = '1px'
    }
    if (thirdPart) {
      if (isStringNum(thirdPart)) {
        let v = toRem(thirdPart)
        if (secondPart === 'x') {
          rule = `margin-right:calc(${v}*var(--space-x-reverse,0));margin-left:calc(${v}*(1 - var(--space-x-reverse,0)))`
        }
        else if (secondPart === 'y') {
          rule = `margin-top:calc(${v}*(1 - var(--space-y-reverse,0)));margin-bottom:calc(${v}*var(--space-y-reverse,0))`
        }
      }
      else if (thirdPart === 'reverse') {
        rule = `--space-${secondPart}-reverse:1`
      }
    }
  },
  divide: () => {
    pseudos = ['>:not(template)~:not(template)']
    sheetLevel = 1
    if (!fourthPart) {
      let v
      if (isNum(thirdPart)) {
        v = thirdPart + 'px'
      }
      else if (isStringNum(thirdPart)) {
        v = thirdPart
      }
      else if (thirdPart === 'reverse') {
        rule = `--divide-${secondPart}-reverse:1`
      }
      else if (secondPart) {
        v = '1px'
      }

      if (v) {
        if (secondPart === 'y') {
          rule = `border-top-width:calc(${v}*calc(1 - var(--divide-y-reverse,0)));border-bottom-width:calc(${v}*var(--divide-y-reverse,0)))`
        }
        else if (secondPart === 'x') {
          rule = `border-right-width:calc(${v}*var(--divide-x-reverse,0));border-left-width:calc(${v}*calc(1 - var(--divide-x-reverse,0)))`
        }
      }
    }
    if (!rule) setColor('border-color')
  },
  min: () => {
    let prefix
    if (secondPart === 'w') prefix = 'width'
    else if (secondPart === 'h') prefix = 'height'
    else return
    let pos = indexOf('xs!sm!md!lg!xl', thirdPart)
    if (pos > -1) {
      rule = `min-${prefix}:${pos * 4 + 20}rem`
    }
    else if (thirdPart.includes('/')) {
      let fractions = thirdPart.split('/')
      if (fractions.length === 2) rule = 'min-' + prefix + ':' + (100 * Number(fractions[0]) / Number(fractions[1])).toFixed(2) + '%'
    }
    else if (isStringNum(thirdPart)) {
      if (thirdPart.endsWith('xl')) {
        rule = `min-${prefix}:${parseInt(thirdPart) * 8 + 24}rem`
      }
      else {
        rule = 'min-' + prefix + ':' + toRem(thirdPart)
      }
    }
  },
  max: () => {
    let prefix
    if (secondPart === 'w') prefix = 'width'
    else if (secondPart === 'h') prefix = 'height'
    else return
    let pos = indexOf('xs!sm!md!lg!xl', thirdPart)
    if (pos > -1) {
      rule = `max-${prefix}:${pos * 4 + 20}rem`
    }
    else if (thirdPart.includes('/')) {
      let fractions = thirdPart.split('/')
      if (fractions.length === 2) rule = 'max-' + prefix + ':' + (100 * Number(fractions[0]) / Number(fractions[1])).toFixed(2) + '%'
    }
    else if (isStringNum(thirdPart)) {
      if (thirdPart.endsWith('xl')) {
        rule = `max-${prefix}:${parseInt(thirdPart) * 8 + 24}rem`
      }
      else {
        rule = 'max-' + prefix + ':' + toRem(thirdPart)
      }
    }
  },
  tracking: () => {
    if (isStringNum(secondPart)) rule = 'letter-spacing:' + secondPart
  },
  leading: () => {
    if (isNum(secondPart)) {
      rule = `line-height:${Number(secondPart) * 0.25}rem`
    }
    else if (isStringNum(secondPart)) {
      rule = 'line-height:' + secondPart
    }
  },
  placeholder: () => {
    pseudos.push('::placeholder')
    setColor('color')
  },
  align: () => {
    if (includes('baseline!top!middle!bottom!text-top!text-bottom', rest)) {
      rule = 'vertical-align:' + rest
    }
  },
  bg: () => {
    if (includes('bottom!center!left!left-bottom!left-top!right!right-bottom!right-top!top', rest)) {
      rule = 'background-position:' + rest.replace('-', ' ')
    }
    else if (includes('repeat!no-repeat!repeat-x!repeat-y', rest)) {
      rule = 'background-repeat:' + rest
    }
    else if (includes('repeat-round!repeat-space', rest)) {
      rule = 'background-repeat:' + rest.replace('repeat-','')
    }
    else if (includes('auto!cover!contain', rest)) {
      rule = 'background-size:' + rest
    }
    else if (includes('fixed!local!scroll', secondPart)) {
      rule = 'background-attachment:' + secondPart
    }
    else if (secondPart === 'none') {
      rule = 'background: none'
    }
    else if (secondPart === 'gradient') {
      var direction = fourthPart[0] === 't' ? 'top' : fourthPart[0] === 'b' ? 'bottom' : ''
      if (fourthPart.length > 1) {
        fourthPart = fourthPart[1]
        direction += ' '
      }
      direction += fourthPart[0] === 'r' ? 'right' : fourthPart[0] === 'l' ? 'left' : ''
      rule = 'background-image: linear-gradient(to ' + direction + ', var(--tw-gradient-stops))'
    }
    else {
      setColor('background-color')
    }
  },
  from: () => {
    if (secondPart === 'inherit') {
      rule = '--tw-gradient-from: inherit;--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(255 255 255 / 0))'
    }
    else if (secondPart === 'current') {
      rule = '--tw-gradient-from: currentColor;--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(255 255 255 / 0))'
    }
    else if (secondPart === 'transparent') {
      rule = '--tw-gradient-from: transparent;--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(0 0 0 / 0))'
    }
    else {
      const [color /*, opacity*/] = parseColor()
      rule = `--tw-gradient-from: #${color};--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(${parseInt(color.slice(0, 2), 16)},${parseInt(color.slice(2, 4), 16)},${parseInt(color.slice(4, 6), 16)} / 0))`
    }
  },
  via: () => {
    if (secondPart === 'inherit') {
      rule = '--tw-gradient-stops: var(--tw-gradient-from), inherit, var(--tw-gradient-to, rgb(255 255 255 / 0))'
    }
    else if (secondPart === 'current') {
      rule = '--tw-gradient-stops: var(--tw-gradient-from), currentColor, var(--tw-gradient-to, rgb(255 255 255 / 0))'
    }
    else if (secondPart === 'transparent') {
      rule = '--tw-gradient-stops: var(--tw-gradient-from), transparent, var(--tw-gradient-to, rgb(0 0 0 / 0))'
    }
    else {
      const [color/*, opacity*/] = parseColor()
      rule = `--tw-gradient-stops: var(--tw-gradient-from), #${color}, var(--tw-gradient-to, rgb(${parseInt(color.slice(0, 2), 16)},${parseInt(color.slice(2, 4), 16)},${parseInt(color.slice(4, 6), 16)} / 0))`
    }
  },
  to: () => {
    if (secondPart === 'inherit') {
      rule = '--tw-gradient-to: inherit'
    }
    else if (secondPart === 'current') {
      rule = '--tw-gradient-to: currentColor'
    }
    else if (secondPart === 'transparent') {
      rule = '--tw-gradient-to: transparent'
    }
    else {
      const [color/*, opacity*/] = parseColor()
      rule = `--tw-gradient-to: #${color}`
    }
  },
  rounded: () => {
    let v
    let pos = roundedSize.indexOf(lastPart)
    if (isStringNum(lastPart)) {
      v = lastPart
      pos = 9
    }
    else if (pos === 7) {
      v = '9999px'
    }
    else if (pos > -1) {
      v = pos * 0.125 + 'rem'
    }
    else if (!secondPart || edge[secondPart] || (includes('t!b', secondPart[0]) && includes('r!l', secondPart[1]))) {
      v = '0.25rem'
    }
    if (v) {
      let place1 = edge[secondPart[0]]
      if (!secondPart || (!thirdPart && pos > -1)) {
        rule = 'border-radius:' + v
      }
      else if (includes('t!b', secondPart)) {
        sheetLevel = 1
        rule = `border-${place1}-left-radius:${v};border-${place1}-right-radius:` + v
      }
      else if (includes('l!r', secondPart)) {
        sheetLevel = 1
        rule = `border-top-${place1}-radius:${v};border-bottom-${place1}-radius:` + v
      }
      else {
        sheetLevel = 2
        rule = `border-${place1}-${edge[secondPart[1]]}-radius:` + v
      }
    }
  },
  border: () => {
    let b = edge[secondPart]
    if (thirdPart && b) {
      if (isNum(thirdPart)) {
        sheetLevel = 1
        rule = `border-${b}-width:${thirdPart}px`
      }
      else if (isStringNum(thirdPart)) {
        rule = `border-${b}-width:` + thirdPart
      }
    }
    else {
      if (includes('solid!dashed!dotted!double!none', secondPart)) {
        rule = 'border-style:' + secondPart
      }
      else if (b) {
        sheetLevel = 1
        rule = `border-${b}-width:1px`
      }
      else if (isNum(secondPart)) {
        rule = `border-width:${secondPart}px`
      }
      else if (isStringNum(secondPart)) {
        rule = 'border-width:' + secondPart
      }
      else {
        setColor('border-color')
      }
    }
  },
  opacity: () => {
    if (isNum(secondPart)) {
      rule = 'opacity:' + secondPart / 100.0
    }
  },
  transition: () => {
    let ruleFunc = (value) => `-webkit-transition-property:${value};-o-transition-property:${value};transition-property:` + value
    let ruleFunc2 = (value) => `-webkit-transition-property:-webkit-${value};transition-property:-webkit-${value};-o-transition-property:${value};transition-property:${value};transition-property:${value},-webkit-${value}`
    if (!secondPart) {
      rule = '-webkit-transition-property:S-webkit-box-shadow,-webkit-transform;transition-property:S-webkit-box-shadow,-webkit-transform;-o-transition-property:Sbox-shadow,transform;transition-property:Sbox-shadow,transform;transition-property:Sbox-shadow,transform,-webkit-box-shadow,-webkit-transform'
      rule = rule.replace(/S/g, 'background-color,border-color,color,fill,stroke,opacity,max-height,min-height,max-width,min-width,')
    }
    else if (secondPart === 'colors') {
      rule = ruleFunc('background-color,border-color,color,fill,stroke')
    }
    else if (secondPart === 'shadow') {
      rule = ruleFunc2('box-shadow')
    }
    else if (secondPart === 'transform') {
      rule = ruleFunc2('transform')
    }
    else if (secondPart === 'height' || (secondPart === 'max' && thirdPart === 'height')) {
      rule = ruleFunc2('max-height')
    }
    else if (secondPart === 'min' && thirdPart === 'height') {
      rule = ruleFunc2('min-height')
    }
    else if (secondPart === 'width' || (secondPart === 'max' && thirdPart === 'width')) {
      rule = ruleFunc2('max-width')
    }
    else if (secondPart === 'min' && thirdPart === 'width') {
      rule = ruleFunc2('min-width')
    }
    else if (secondPart) {
      rule = ruleFunc(secondPart)
    }
  },
  duration: timeProp,
  delay: timeProp,
  ease: () => {
    let ruleFunc = (value) => `-webkit-transition-timing-function:${value};-o-transition-timing-function:${value};transition-timing-function:${value}`
    if (rest === 'in') {
      rule = ruleFunc('cubic-bezier(0.4,0,1,1)')
    }
    else if (rest === 'out') {
      rule = ruleFunc('cubic-bezier(0,0,0.2,1)')
    }
    else if (rest === 'in-out') {
      rule = ruleFunc('cubic-bezier(0.4,0,0.2,1)')
    }
    else if (rest === 'linear') {
      rule = ruleFunc('linear')
    }
  },
  scale: () => {
    if (isNum(lastPart)) {
      let v = lastPart / 100
      if (includes('x!y', secondPart)) {
        sheetLevel = 1
        rule = `--transform-scale-${secondPart}:` + v
      }
      else {
        rule = `--transform-scale-x:${v};--transform-scale-y:` + v
      }
    }
  },
  rotate: () => {
    if (isNum(secondPart)) {
      rule = `--transform-rotate:${negative}${secondPart}deg`
    }
  },
  translate: () => {
    if (includes('x!y', secondPart)) {
      if (thirdPart === 'px') {
        thirdPart = '1px'
      }
      else if (thirdPart === 'full') {
        thirdPart = '100%'
      }
      else if (thirdPart.includes('/')) {
        let fractions = thirdPart.split('/')
        if (fractions.length === 2) thirdPart = (100 * Number(fractions[0]) / Number(fractions[1])).toFixed(2) + '%'
      }
      else if (isNum(thirdPart)) {
        thirdPart = Number(thirdPart) * 0.25 + 'rem'
      }
      if (isStringNum(thirdPart)) {
        rule = `--transform-translate-${secondPart}:${negative}${thirdPart}`
      }
    }
    else {
      if (secondPart === 'px') {
        secondPart = '1px'
      }
      else if (secondPart === 'full') {
        secondPart = '100%'
      }
      else if (secondPart.includes('/')) {
        let fractions = secondPart.split('/')
        if (fractions.length === 2) secondPart = (100 * Number(fractions[0]) / Number(fractions[1])).toFixed(2) + '%'
      }
      else if (isNum(secondPart)) {
        secondPart = Number(secondPart) * 0.25 + 'rem'
      }
      if (isStringNum(secondPart)) {
        rule = `--transform-translate-x:${negative}${secondPart}; --transform-translate-y:${negative}${secondPart}`
      }
    }
  },
  skew: () => {
    if (includes('x!y', secondPart) && isNum(thirdPart)) {
      rule = `--transform-skew-${secondPart}:${negative + thirdPart}deg`
    }
  },
  transform: () => {
    let v = 'translatex(var(--transform-translate-x,0))translatey(var(--transform-translate-y,0))rotate(var(--transform-rotate,0))skewx(var(--transform-skew-x,0))skewy(var(--transform-skew-y,0))scalex(var(--transform-scale-x,1))scaley(var(--transform-scale-y,1))'
    rule = `-webkit-transform:${v};-ms-transform:${v};transform:` + v
  },
  origin: () => {
    if (includes('center!top!top-right!right!bottom-right!bottom!bottom-left!left!top-left', rest)) {
      rest = rest.replace('-', ' ')
      rule = `-webkit-transform-origin:${rest};-ms-transform-origin:${rest};transform-origin:` + rest
    }
  },
  cursor: () => {
    if (includes('auto!default!pointer!wait!text!move!not-allowed', rest)) {
      rule = 'cursor:' + rest
    }
  },
  shadow: () => {
    let shadows = newObject({
      xs: '0 0 0 1pxR.05)',
      sm: '0 1px 2px 0R.05)',
      '': '0 1px 3px 0R.1), 0 1px 2px 0R.06)',
      md: '0 4px 6px -1pxR.1), 0 2px 4px -1pxR.06)',
      lg: '0 10px 15px -3pxR.1), 0 4px 6px -2pxR.05)',
      xl: '0 20px 25px -5pxR.1), 0 10px 10px -5pxR.04)',
      '2xl': '0 25px 50px -12pxR.25)',
      inner: 'inset 0 2px 4px 0R.06)',
      outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',
      none: 'none'
    })
    let v = shadows[secondPart]
    if (v) {
      v = v.replace(/R/g, ' rgba(0, 0, 0, 0')
      // console.log(v)
      rule = `-webkit-box-shadow:${v};box-shadow:` + v
    }
  },
  outline: () => {
    if (secondPart) {
      rule = 'outline:' + rest.replace('-', ' ')
    }
  },
  pointer: () => {
    if (secondPart) {
      rule = 'pointer-events:' + thirdPart
    }
  },
  select: () => {
    if (includes('none!auto!text!contain!all!inherit!initial!unset', rest)) {
      rule = `-webkit-user-select:${rest};-moz-user-select:${rest};-ms-user-select:${rest};user-select:` + rest
    }
  },
  fill: () => {
    if (secondPart) setColor('fill')
  },
  stroke: () => {
    if (isNum(secondPart)) {
      rule = 'stroke-width:' + secondPart
    }
    else if (secondPart) {
      setColor('stroke')
    }
  },
  items: () => {
    if (includes('stretch!start!center!end!baseline', rest)) {
      rule = `-webkit-box-align:${rest};-ms-flex-align:${rest};align-items:` + (includes('start!end', rest) ? 'flex-' : '') + rest
    }
  },
  content: () => {
    if (includes('start!center!end!between!around', lastPart)) {
      let v = rest
      if (includes('start!end', rest)) {
        rest = 'flex-' + rest
      }
      else if (rest === 'between') {
        v = 'justify'
        rest = 'space-' + rest
      }
      else if (rest === 'around') {
        v = 'distribute'
        rest = 'space-' + rest
      }
      rule = `-ms-flex-line-pack:${v};align-content:` + rest
    }
  },
  self: () => {
    if (includes('auto!start!center!end!stretch', rest)) {
      let gridRowAlign = `-ms-grid-row-align:${rest};`
      let v = rest
      if (includes('start!end', rest)) {
        rest = 'flex-' + rest
        gridRowAlign = ''
      }
      rule = `-ms-flex-item-align:${v};${gridRowAlign}align-self:` + rest
    }
  },
  justify: () => {
    if (includes('start!center!end!between!around', rest)) {
      let v = rest
      if (v === 'between') {
        v = 'justify'
        rest = 'space-' + rest
      }
      else if (includes('start!end')) {
        rest = 'flex-' + rest
      }
      let webkit = `-webkit-box-pack:${v};`
      if (v === 'around') {
        v = 'distribute'
        rest = 'space-' + rest
        webkit = ''
      }
      rule = webkit + `-ms-flex-pack:${v};justify-content:` + rest
    }
  }
})

let firstPart
let secondPart
let thirdPart
let fourthPart
let lastPart
let partsWithoutEnd
let rest
let negative
let rule
let pseudos
let variant
const variantRegex = /^([^:]+):(.+)$/g
const pseudosRegex = /[^:]+::?|.+/g
const specialChars = /[.*+\-?^${}()|[\]\\]/g
let sheetLevel

function processClass(skipSetRule) {
  sheetLevel = 0
  rule = ''
  negative = ''
  originalClass = cls
  variant = variantRegex.exec(cls)
  if (variant && (variant[1] === 'dark' || variant[1] === 'light')) {
    // we need to remove variant from originalClass for setRule to function properly
    originalClass = cls = variant[2]
    variant = variant[1]
  }
  else variant = ''
  let separator = config.separator
  if (separator !== ':') {
    cls = cls.replace(new RegExp(separator.replace(specialChars, '\\$&'), 'g'), ':')
  }
  pseudos = cls.match(pseudosRegex)
  cls = pseudos.pop()
  pseudos = pseudos.map((v) => (v.endsWith('::') ? '::' + v.slice(0, -2) : ':' + v.slice(0, -1)))
  let customData = customCache.get(cls)
  if (customData) {
    let [classes, props] = customData
    let [pseudosStr, originalPseudos] = [originalClass.slice(0, originalClass.lastIndexOf(cls)), pseudos]
    componentName = originalClass
    if (typeof classes === 'string') {
      for (cls of classes.trim().replace(/\s\s+/g, ' ').split(' ')) {
        cls = pseudosStr + cls
        processClass()
      }
    }
    pseudos = originalPseudos
    if (props && typeof props === 'string') setRule(props)
    componentName = ''
    return
  }

  if (cls[0] === '-') {
    negative = '-'
    cls = cls.slice(1)
  }

  if (typeof config.prefix === 'string') {
    if (!cls.startsWith(config.prefix)) {
      notFound()
      return
    }
    else {
      cls = cls.slice(config.prefix.length)
    }
  }
  let parts = cls.split('-');
  [firstPart, secondPart = '', thirdPart = '', fourthPart = ''] = parts
  lastPart = parts[parts.length - 1]
  partsWithoutEnd = parts.slice(0, -1).join('-')
  rest = parts.slice(1).join('-')

  let process
  if (!(rule = classNames[cls]) && (process = cls2process[firstPart])) {
    process()
  }
  else if (firstPart.length < 3 && !thirdPart) {
    formatClass()
  }

  if (skipSetRule) {
    if (!rule) notFound()
    return
  }

  if (rule) {
    setRule(rule)
  }
  else if (cls === 'container') {
    setRule('width:100%')
    for (const [r, size] of Object.entries(config.screens)) {
      setRule('max-width:' + size, media.get(`default${r}0`))
    }
  }
  else {
    notFound()
  }
}

function formatClass () {
  let v
  if (firstPart === 'z') {
    v = negative + secondPart
  }
  else {
    if (secondPart === 'px') {
      v = `${negative}1px`
    }
    else if (secondPart === 'full') {
      v = '100%'
    }
    else if (secondPart === 'screen') {
      if (firstPart === 'w') v = '100vw'
      else if (firstPart === 'h') v = '100vh'
    }
    else if (secondPart === 'auto') {
      v = 'auto'
    }
    else if (isNum(secondPart)) {
      v = negative + Number(secondPart) * 0.25 + 'rem'
    }
    else if (secondPart.indexOf('/') > -1) {
      let [top, bottom] = secondPart.split('/')
      if (isNum(top) && isNum(bottom)) v = negative + (100 * Number(top) / Number(bottom)).toFixed(2) + '%'
    }
    else if (isStringNum(secondPart)) {
      v = negative + secondPart
    }
  }

  let basicPart = formatters[firstPart[0]]
  let e = edge[firstPart[1]]
  if (v && basicPart) {
    if (firstPart[1] === 'x') {
      sheetLevel = 1
      rule = basicPart + `-right:${v};${basicPart}-left:` + v
    }
    else if (firstPart[1] === 'y') {
      sheetLevel = 1
      rule = basicPart + `-top:${v};${basicPart}-bottom:` + v
    }
    else if (e) {
      sheetLevel = 2
      rule = basicPart + `-${e}:` + v
    }
    else {
      rule = basicPart + ':' + v
    }
  }
}

let findInSheet = (sheet) => {
  if (sheet.href && new URL(sheet.href).origin !== window.location.origin) return []
  let rules = []
  for (let rule of [...sheet.cssRules]) {
    // eslint-disable-next-line no-undef
    if (rule.type === CSSRule.STYLE_RULE) {
      if (rule.selectorText.split(',').map((item) => item.trim()).includes('.' + cls)) {
        let text = rule.cssText
        rules.push([text.slice(text.indexOf('{') + 1, text.lastIndexOf('}')), sheet])
      }
    }
    else if (rule.type === CSSRule.MEDIA_RULE) {
      rules.push(...findInSheet(rule))
    }
  }
  return rules
}

let responsiveSheets = new Map()

let notFound = () => {
  if (pseudos.length > 0) {
    let rules = []
    for (const sheet of document.styleSheets) {
      rules.push(...findInSheet(sheet))
    }
    let responsive = pseudos[0].slice(1)
    if (config.screens[responsive]) {
      let screens = Object.entries(config.screens)
      for (let [rule, sheet] of rules) {
        let sheets = responsiveSheets.get(sheet)
        if (!sheets) {
          sheets = newObject()
          for (const [r, size] of screens) {
            sheets[r] = sheet.cssRules[sheet.insertRule(`@media(min-width:${size}){}`, sheet.cssRules.length)]
          }
          responsiveSheets[sheet] = sheets
        }
        setRule(rule, sheets[responsive])
      }
    }
    else {
      for (let [rule, sheet] of rules) {
        // keeps all rules inserted into the same sheet:
        // rules can be set to media queries but should not be added to
        // any sheets other than parentSheet
        setRule(rule, sheet.parentStyleSheet ? sheet : null)
      }
    }
  }
}

let pseudoVendorPrefixes = newObject({
  '::placeholder': '::-webkit-input-placeholder!::-moz-placeholder!:-ms-input-placeholder!::-ms-input-placeholder','::selection': ':::-moz-selection'
})

function setRule(rule, sheet) {
  let pseudo = ''
  let ruleCls = originalClass.replace(/[.:()&@~*^$%,#/]/g, '\\$&')
  let sheetPrefix = 'default'
  let important = ''
  let insertRule = () => {
    try {
      if (variant) sheet.insertRule(important + `.${variant} .${variant}\\:${ruleCls}${pseudo}{${rule}}`, sheet.cssRules.length)
      else sheet.insertRule(important + `.${ruleCls}${pseudo}{${rule}}`, sheet.cssRules.length)
    }
    catch (err) {
      console.log(err)
    }
  }

  if (componentName) {
    ruleCls = componentName
    sheetPrefix = 'custom'
  }

  if (config.important) {
    if (config.important === true) {
      rule = rule.replace(/;/g, '!important;') + '!important'
    }
    else if (typeof config.important === 'string') {
      important = config.important + ' '
    }
  }

  if (pseudos.length > 0) {
    let mediaQuery = media.get(sheetPrefix + pseudos[0].slice(1) + sheetLevel)
    if (mediaQuery) {
      sheet = sheet || mediaQuery
      pseudos.shift()
    }
  }

  if (!sheet) sheet = media.get(sheetPrefix + sheetLevel)

  if (pseudos.length > 0) {
    for (const pseudo of [...pseudos]) {
      let prefixes = pseudoVendorPrefixes[pseudo]
      if (prefixes) pseudos.push(...split(prefixes))
    }
    for (pseudo of pseudos) {
      if (includes(':first!:last', pseudo)) {
        pseudo += '-child'
      }
      else if (includes(':odd!:even', pseudo)) {
        pseudo = `:nth-child(${pseudo.slice(1)})`
      }
      else if (pseudo === ':group-hocus') {
        pseudo = ''
        const origRuleCls = ruleCls 
        ruleCls = 'group:hover ' + ruleCls
        insertRule()
        ruleCls = 'group:focus ' + origRuleCls
      }
      else if (pseudo.startsWith(':group')) {
        ruleCls = pseudo.slice(1).replace('-', ':') + ' .' + ruleCls
        pseudo = ''
      }
      else if (pseudo === ':hocus') {
        pseudo = ':hover'
        insertRule()
        pseudo = ':focus'
      }
      insertRule()
    }
  }
  else {
    insertRule()
  }
}


export const addClass = (name, classes, props) => {
  if (typeof name !== 'string') throw Error('Component must have a name')
  if (classesCache.get(name)) return console.error('Component ' + name + ' already defined')
  name = name.trim()
  if (typeof props === 'object') {
    var classesString = ''
    forEach(props, function(value, key) {
      if (typeof value === 'number' && !/font|line/.test(key)) value += 'px'
      classesString += camelToSnakeCase(key) + ':' + value + ';'
    })
    props = classesString
  }
  customCache.set(name, [classes, props])
}


const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)


export const addCss = function(css) {
  if (typeof window === 'undefined') return
  if (!addedScreens) {
    addedScreens = true
    let entries = Object.entries(config.screens)
    for (const m of split('custom!default')) {
      setMedia(m)
      for (const [key, size] of entries) {
        setMedia(m + key, size)
      }
    }
  }
  if (typeof css === 'object') {
    let sheet = media.get('custom0')
    forEach(css, function(props, selector) {
      let rule = ''
      if (typeof props === 'object') {
        forEach(props, function(value, key) {
          if (typeof value === 'number' && !/font|line/.test(key)) value += 'px'
          rule += camelToSnakeCase(key) + ':' + value + ';'
        })
      }
      else rule += props
      try { sheet.insertRule(selector+'{'+rule+'}', sheet.cssRules.length) }
      catch(err) { }
    })
  }
  else {
    var open = 0
    var prevIndex = 0
    var sheetPrefix = 'custom'
    for (var i = 0; i < css.length; i++) {
      if (css[i] === '}') {
        --open
        if (open === 0) {
          var cssString = css.substring(prevIndex, i + 1)
          var index = cssString.indexOf('{')
          var selector = cssString.substring(0, index).trim().replace(/\n/g,' ').replace(/\s\s+/g,' ')
          var properties = cssString.substring(index+1, cssString.length-1).trim().split(';')
          var important = ''
          // eslint-disable-next-line
          properties.forEach((string) => {
            if (/@apply/.test(string.trim())) {
              let classes = string.replace(/\s*@apply\s+/, '').split(/\s+/)
              let ruleCls = selector // note: includes leading . if applicable
              if (last(classes) === '!important') {
                classes.pop()
                important = ' !important '
              }
              classes.forEach(function(myCls) {
                let sheet = null
                let pseudo = ''
                let insertRule = () => {
                  try {
                    if (variant) sheet.insertRule(`.${variant} ${ruleCls}${pseudo}{${rule}${important}}`, sheet.cssRules.length)
                    else sheet.insertRule(`${ruleCls}${pseudo}{${rule}${important}}`, sheet.cssRules.length)
                  }
                  catch (err) {
                    console.log(err)
                  }
                }
                cls = myCls
                processClass(true)
                if (!rule) return

                if (pseudos.length > 0) {
                  let mediaQuery = media.get(sheetPrefix + pseudos[0].slice(1) + sheetLevel)
                  if (mediaQuery) {
                    sheet = mediaQuery
                    pseudos.shift()
                  }
                }
              
                if (!sheet) sheet = media.get(sheetPrefix + sheetLevel)
              
                if (pseudos.length > 0) {
                  for (const pseudo of [...pseudos]) {
                    let prefixes = pseudoVendorPrefixes[pseudo]
                    if (prefixes) pseudos.push(...split(prefixes))
                  }
                  for (pseudo of pseudos) {
                    if (includes(':first!:last', pseudo)) {
                      pseudo += '-child'
                    }
                    else if (includes(':odd!:even', pseudo)) {
                      pseudo = `:nth-child(${pseudo.slice(1)})`
                    }
                    else if (pseudo === ':group-hocus') {
                      pseudo = ''
                      ruleCls = 'group:hover ' + selector
                      insertRule()
                      ruleCls = 'group:focus ' + selector
                    }
                    else if (pseudo.startsWith(':group')) {
                      ruleCls = pseudo.slice(1).replace('-', ':') + ' ' + selector
                      pseudo = ''
                    }
                    insertRule()
                  }
                }
                else {
                  insertRule()
                }
              })
            }
            else if (string) {
              try { 
                let sheet = media.get(sheetPrefix + '0')
                sheet.insertRule(selector + '{' + string + '}', sheet.cssRules.length) 
              }
              catch(err) { }
            }
          })
          prevIndex = i + 1
        }
      }
      else if (css[i] === '{') ++open
    }
  }
}

// taken from preflight.css
// https://github.com/creativetimofficial/material-tailwind/blob/main/assets/styles/index.css
addCss('html,body{line-height:1.5;-webkit-text-size-adjust:100%;overflow-x:hidden;-webkit-box-sizing:border-box;  -moz-box-sizing:border-box;box-sizing:border-box;margin:0;overscroll-behavior:none;font-family:Poppins;}main{display:block}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:600}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button;outline:0!important}[type=button]:focus,[type=reset]:focus,[type=submit]:focus,button:focus{-webkit-appearance:button;outline:0!important;box-shadow:none;border:none}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}button{background-color:transparent;background-image:none;padding:0}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}fieldset{margin:0;padding:0}ol,ul{list-style:none;margin:0;padding:0}*,::before,::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e2e8f0}hr{border-top-width:1px}img{border-style:solid}textarea{resize:vertical}input:-ms-input-placeholder,textarea:-ms-input-placeholder{color:#a0aec0}input::-ms-input-placeholder,textarea::-ms-input-placeholder{color:#a0aec0}input::placeholder,textarea::placeholder{color:#a0aec0}[role=button],button{cursor:pointer}table{border-collapse:collapse}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}button,input,optgroup,select,textarea{padding:0;line-height:inherit;color:inherit}code,kbd,pre,samp{font-family:"Courier New",monospace}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}iframe{overscroll-behavior:none;}img,video{max-width:100%;height:auto}')

if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  window.processClasses = processClasses
  window.addCss = addCss
}
